// 订单管理
import { Layout } from '@/utils/routerHelper'

export default {
  path: '/order',
  redirect: '/order/direct-selling-order-list',
  component: Layout,
  name: 'Order',
  meta: {
    title: '订单管理',
    icon: 'vi-ant-design:dashboard-filled'
  },
  children: [
    {
      path: 'direct-selling-order-list',
      component: () => import('@/views/Order/DirectSelling/OrderList/Index.vue'),
      // name: 'DirectSellingOrderList',
      name: 'OrderList',
      meta: {
        title: '直销区订单列表'
      },
      children: [
        {
          path: 'order-detail',
          component: () => import('@/views/Order/DirectSelling/OrderDetail/Index.vue'),
          //  name: 'DirectSellingOrderDetail',
          name: 'OrderDetail',
          meta: {
            title: '订单详情',
            hidden: true,
            canTo: true,
            activeMenu: '/order/direct-selling-order-list'
          }
        }
      ]
    },
    {
      path: 'direct-selling-refund-failed',
      component: () => import('@/views/Order/DirectSelling/RefundFailed/Index.vue'),
      // name: 'DirectSellingRefundFailed',
      name: 'RefundFailed',
      meta: {
        title: '直销区退款失败订单'
      },
      children: [
        {
          path: 'refund-failed-detail',
          component: () => import('@/views/Order/DirectSelling/RefundFailedDetail/Index.vue'),
          // name: 'DirectSellingRefundFailedDetail',
          name: 'RefundFailedDetail',
          meta: {
            title: '退款失败订单详情',
            hidden: true,
            canTo: true,
            activeMenu: '/order/direct-selling-refund-failed'
          }
        }
      ]
    },
    {
      path: 'direct-selling-sku-order-list',
      component: () => import('@/views/Order/DirectSelling/SkuOrderList/Index.vue'),
      // name: 'DirectSellingSkuOrderList',
      name: 'SkuOrderList',
      meta: {
        title: '直销区SKU订单列表'
      }
    },
    {
      path: 'direct-selling-customs-declaration',
      component: () => import('@/views/Order/DirectSelling/CustomsDeclaration/Index.vue'),
      // name: 'DirectSellingCustomsDeclaration',
      name: 'CustomsDeclaration',
      meta: {
        title: '报单列表'
      },
      children: [
        {
          path: 'customs-declaration-detail',
          component: () => import('@/views/Order/DirectSelling/CustomsDeclarationDetail/Index.vue'),
          // name: 'DirectSellingCustomsDeclarationDetail',
          name: 'CustomsDeclarationDetail',
          meta: {
            title: '报单详情',
            hidden: true,
            canTo: true,
            activeMenu: '/order/direct-selling-customs-declaration'
          }
        }
      ]
    },
    {
      path: 'public-order-list',
      component: () => import('@/views/Order/Public/OrderList/Index.vue'),
      name: 'PublicOrderList',
      meta: {
        title: '公共区订单列表'
      },
      children: [
        {
          path: 'public-order-detail',
          component: () => import('@/views/Order/Public/OrderDetail/Index.vue'),
          name: 'PublicOrderDetail',
          meta: {
            title: '订单详情',
            hidden: true,
            canTo: true,
            activeMenu: '/order/public-order-list'
          }
        }
      ]
    },
    {
      path: 'lead-order-list',
      component: () => import('@/views/Order/Lead/OrderList/Index.vue'),
      name: 'LeadOrderList',
      meta: {
        title: '领参区订单列表'
      },
      children: [
        {
          path: 'lead-order-detail',
          component: () => import('@/views/Order/Lead/OrderDetail/Index.vue'),
          name: 'LeadOrderDetail',
          meta: {
            title: '订单详情',
            hidden: true,
            canTo: true,
            activeMenu: '/order/lead-order-list'
          }
        }
      ]
    }
  ]
}
